export enum RecommendableEntityType {
  USER = 'user',
  INTERVIEW = 'interview',
  INTERVIEW_SERIES = 'interview-series',
}

export interface RecommendedItemMetadata {
  originalId: string;
  entityType: RecommendableEntityType;
  createdAt: string;
  title?: string;
  description?: string;
  // For interviews
  tags?: string[];
  company?: string;
  companyId?: string;
  companyLogo?: string;
  companyLogoUrl?: string;
  role?: string;
  difficulty?: number;
  durationMinutes?: number;
  isActive?: boolean;
  features?: string[];
  voicePack?: string;
  characterGender?: string;
  // For interview series
  name?: string; // Series use 'name', interviews use 'title' for the main display string
  enrollmentCount?: number;
  totalTimeMinutes?: number;
  passScore?: number;
  preparationTimeWeeks?: string;
  successRate?: number;
  interviews?: any[]; // Simplified for now, could be array of basic interview info
  // Common custom fields
  [key: string]: any; 
}

export interface RecommendedItem {
  id: string;
  type: RecommendableEntityType;
  score?: number;
  title?: string; // This will be the primary display title
  description?: string;
  metadata: RecommendedItemMetadata; // Strongly typed metadata
  
  // Additional properties for UI display (populated from metadata)
  company?: string;
  companyId?: string;
  companyLogo?: string;
  role?: string;
  jobRoleId?: string;
  jobRoleTitle?: string;
  difficulty?: number;
  durationMinutes?: number;
  totalTimeMinutes?: number;
  isActive?: boolean;
  passScore?: number;
  match_score?: number; // Duplicate of score for compatibility
  matchScore?: number; // Duplicate of score for compatibility
}

// Wrapper for API responses, assuming it's generic
export interface ApiResponse<T> {
  statusCode: number;
  message: string;
  data: T;
}

// Request DTO for fetching recommendations (mirrors backend's RecommendQueryDto)
export interface RecommendQueryDto {
  queryText?: string;
  userId?: string;
  itemIdForContext?: string;
  itemTypeForContext?: RecommendableEntityType;
  itemTypeToRecommend: RecommendableEntityType; // This is now part of the body
  limit?: number;
  filters?: Record<string, any>;
} 